import React from "react";
import { Layout } from "antd";
import Header from "../common/header";
import Footer from "../common/footer";

const { Content } = Layout;

function Main({ children }: any) {

    return (
        <Layout>
            <div className="row-layout">
                <Header />
                <Content>{children}</Content>
                <Footer />
            </div>
        </Layout>
    );
}

export default Main;